"use client";

import { ExternalLink } from "lucide-react";
import { trackClick } from "@/lib/analytics";
import { track } from "@/lib/tracking/track";

interface Props {
  slug: string;
  href: string;
  label: string;
}

export function CtaButton({ slug, href, label }: Props) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => {
        trackClick(slug);
        track("event_cta_click", { slug });
      }}
      className="mt-5 inline-flex h-12 w-full items-center justify-center gap-2 rounded-full bg-primary text-sm font-semibold text-primary-foreground transition hover:bg-primary/90"
    >
      <ExternalLink className="h-4 w-4" />
      {label}
    </a>
  );
}
